import { reportForTool, reportsFor } from './reportCatalog';

/**
 * Key pages and the help topic each one maps to; the topic is a knowledge-base search, so a renamed article still
 * matches. `key` is stable: the proxy counts page-help opens against it (engagement.mjs PAGE_KEYS), so keep the
 * two in step.
 */
export const PAGES = [{
  key: 'allocation-table',
  match: /^\/allocation_tables\b/,
  label: 'Allocation table',
  topic: 'allocation table'
}, {
  key: 'allocations',
  match: /^\/allocations\b/,
  label: 'Allocations',
  topic: 'allocation cycle'
}, {
  key: 'resident-record',
  match: /^\/(resident_acount|residencies)\b/,
  label: 'Resident record',
  topic: 'resident'
}, {
  key: 'bills',
  match: /^\/bills\b/,
  label: 'Bills',
  topic: 'upload bill'
}, {
  key: 'property-setup',
  match: /^\/(new_property|edit_property)\b/,
  label: 'Property setup',
  topic: 'property setup'
}, {
  key: 'reporting',
  match: /^\/reporting\b/,
  label: 'Reporting',
  topic: 'report'
}, {
  key: 'fee-structure',
  match: /^\/fee-structure\b/,
  label: 'Fee structure',
  topic: 'fee setup'
}, {
  key: 'team-settings',
  match: /^\/team_settings\b/,
  label: 'Team settings',
  topic: 'team member'
}, {
  key: 'payments-subscriptions',
  match: /^\/payments_and_subscriptions\b/,
  label: 'Payments and subscriptions',
  topic: 'banking information'
}, {
  key: 'payments',
  match: /^\/payments\b/,
  label: 'Payments',
  topic: 'resident payment'
}, {
  key: 'addenda',
  match: /^\/addendums_files\b/,
  label: 'Addenda',
  topic: 'utility addendum'
}, {
  key: 'accounts-receivable',
  match: /^\/ar_report\b/,
  label: 'Accounts receivable',
  topic: 'accounts receivable'
}, {
  key: 'billing',
  match: /^\/billing_module\b/,
  label: 'Billing',
  topic: 'processing a bill'
}, {
  key: 'appfolio',
  match: /^\/appfolio\b/,
  label: 'AppFolio',
  topic: 'AppFolio integration'
}, {
  key: 'bill-files',
  match: /^\/bills_files\b/,
  label: 'Bill files',
  topic: 'bill copies'
}, {
  key: 'add-properties',
  match: /^\/new_properties\b/,
  label: 'Add properties',
  topic: 'add a new property'
}];
export const pageHelpFor = pathname => {
  var _PAGES$find;
  return (_PAGES$find = PAGES.find(p => p.match.test(pathname))) !== null && _PAGES$find !== void 0 ? _PAGES$find : null;
};

/** The report a favorite tool produces, or undefined when the tool is not one we know or not one for this type. */
export function favoriteReportPrompt(billingType, favorite) {
  var _reportForTool;
  return (_reportForTool = reportForTool(favorite, billingType)) === null || _reportForTool === void 0 ? void 0 : _reportForTool.prompt;
}

/**
 * One-click reports for an empty chat, from the catalog and only those that apply to this customer type, with the one
 * this person runs most first.
 */
export function popularReports(billingType, favorite) {
  const reports = [...reportsFor(billingType).slice(0, 3).map(r => r.prompt), 'What’s blocking this month’s billing?'];
  const mine = favoriteReportPrompt(billingType, favorite);
  return mine ? [mine, ...reports.filter(r => r !== mine)] : reports;
}